import { getError } from "@/utils/get-error";
import { MESApiService, axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";
import { ComponentType } from "../../componentTypes/models/ComponentType";
import { Part } from "../models/Part";

export class PartsRepository {
	private axios: Axios;
	constructor() {
		this.axios = axiosInstance;

		this.getParts = this.getParts.bind(this);
		this.getPartById = this.getPartById.bind(this);
		this.createPart = this.createPart.bind(this);
		this.updatePart = this.updatePart.bind(this);
		this.updateComponentTypeByPart = this.updateComponentTypeByPart.bind(this);
		this.deletePart = this.deletePart.bind(this);
	}

	async getParts() {
		try {
			const resp = await this.axios.get("/Part/");

			return {
				ok: true,
				data: resp,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}

	async getPartById(partId: number | null) {
		try {
			const resp = await this.axios.get(`/Part/${partId}`);
			return {
				ok: true,
				data: resp,
			};
		} catch (e: any) {
			return { ok: false, message: e.toString() };
		}
	}
	async createPart({
		partName,
		description,
		sku,
		unit,
		partStateId,
		vendorId,
		refurbishVendor,
		removalDate,
		sendToVendorDate,
		estimatedArrival,
		actualArrival,
		isActive,
	}: Part) {
		try {
			const resp = await this.axios.post("/Part/", {
				partName,
				description,
				sku,
				unit,
				partStateId: partStateId || 1,
				vendorId: vendorId || 1,
				refurbishVendor,
				removalDate,
				sendToVendorDate,
				estimatedArrival,
				actualArrival,
				isActive,
			});
			return {
				ok: true,
				resp,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}

	async updatePart(partId: number | null, data: any) {
		try {
			const resp = await this.axios.patch(`/Part/${partId}`, data);
			return {
				ok: true,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}
	async updateComponentTypeByPart(partId: number | null, ids: any) {
		let idArray: Array<Number> = [];

		ids.forEach((ct: ComponentType) => idArray.push(ct.componentTypeId));

		try {
			const resp = await this.axios.patch(
				`/Part/${partId}/component-types`,
				null,
				{ params: { ids: idArray.toString() } },
			);

			return {
				ok: true,
				data: resp,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}

	async deletePart(partId: number | null) {
		try {
			const resp = await this.axios.delete("/Part/", {
				params: { partId },
			});
			return {
				ok: true,
				resp,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}

	async getPartHistory(partId: number) {
		const api = new MESApiService();
		return await api.callV2("REF.GetPartHistory", [
			{
				name: "PartId",
				value: partId,
			},
		]);
	}
}

export const {
	getParts,
	getPartById,
	createPart,
	updatePart,
	updateComponentTypeByPart,
	deletePart,
	getPartHistory,
} = new PartsRepository();
